import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'react-native';
import styled from 'styled-components/native';

export type TextLink = {
  onPress: () => void;
};

type TextWithLinksProps = {
  i18nKey: string;
  links: Record<string, TextLink>;
  values?: Record<string, string>;
  linkColor?: string;
};

const linkTagPattern = /<(\w+)>(.*?)<\/\1>/;

const StyledLink = styled.Text<{ linkColor?: string }>`
  color: ${(p) => p.linkColor ?? p.theme.colors.primary};
  text-decoration-line: underline;
`;

const TextWithLinks: React.FC<TextWithLinksProps> = ({
  i18nKey,
  links,
  values,
  linkColor,
}) => {
  const { t } = useTranslation();

  const chunks = t(i18nKey, values).split(linkTagPattern);
  const segments: React.ReactNode[] = [];

  for (let index = 0; index < chunks.length; index += 3) {
    const [text, name, label] = chunks.slice(index, index + 3);

    if (text) {
      segments.push(<Text key={`${i18nKey}-text-${index}`}>{text}</Text>);
    }
    if (name === undefined) {
      break;
    }

    const link = links[name];
    segments.push(
      link ? (
        <StyledLink
          key={`${i18nKey}-link-${name}`}
          accessibilityRole="link"
          testID={`${i18nKey}-link-${name}`}
          linkColor={linkColor}
          onPress={link.onPress}>
          {label}
        </StyledLink>
      ) : (
        <Text key={`${i18nKey}-label-${index}`}>{label}</Text>
      )
    );
  }

  return <Text>{segments}</Text>;
};

export default TextWithLinks;
